import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface UpdateProps {
  event_id: number;
  event_title: string;
  event_img: string;
  event_category: string;
  thumbnail_image: string;
  event_date: string;
  slug: string;
}

const UpdateCard: React.FC<{ item: UpdateProps }> = ({ item }) => {
  const [imgLoading, setImgLoading] = useState(true);

  const imageUrl = item?.thumbnail_image || "";
  const hasImage = Boolean(imageUrl);

  useEffect(() => {
    setImgLoading(true);
  }, [imageUrl]);

  return (
    <Link
      to={`/updates/${item.slug}`}
      className="upates_card text-decoration-none text-dark"
    >
      {/* Skeleton */}
      {(imgLoading || !hasImage) && (
        <div className="placeholder-glow">
          <span
            className="placeholder d-block w-100 rounded"
            style={{ height: "180px" }}
          ></span>
        </div>
      )}

      {/* Image */}
      {hasImage && (
        <img
          src={imageUrl}
          alt={item.event_title}
          onLoad={() => setImgLoading(false)}
          onError={() => setImgLoading(false)}
          style={{ display: imgLoading ? "none" : "block" }}
        />
      )}

      <div className="upates_card_info">
        <span className="update_type">{item.event_category}</span>

        <p className="title_heading">
          {item.event_title}
        </p>

        <p className="posting_date">
          {new Date(item.event_date).toDateString()}
        </p>
      </div>
    </Link>
  );
};

export default UpdateCard;
